import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../../../../services/usuario.service';
import { User } from '../../../../../models/user.model';

@Component({
    selector: 'app-reset-password-modal',
    templateUrl: './reset-password-modal.component.html',
    styleUrls: ['./reset-password-modal.component.scss'],
    standalone: false
})
export class ResetPasswordModalComponent implements OnInit {
    @Input() user!: User;

    formResetPassword!: UntypedFormGroup;
    loading = false;

    constructor(
        public activeModal: NgbActiveModal,
        private fb: UntypedFormBuilder,
        private usuarioService: UsuarioService,
        private toastr: ToastrService
    ) { }

    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.formResetPassword = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, {
            validators: this.passwordMatchValidator
        });
    }

    passwordMatchValidator(form: UntypedFormGroup) {
        const password = form.get('password');
        const confirmPassword = form.get('confirmPassword');

        if (password && confirmPassword && password.value !== confirmPassword.value) {
            confirmPassword.setErrors({ passwordMismatch: true });
            return { passwordMismatch: true };
        }
        return null;
    }

    async resetPassword(): Promise<void> {
        if (!this.formResetPassword.valid) {
            this.toastr.warning('Please fill all fields correctly');
            this.formResetPassword.markAllAsTouched();
            return;
        }

        if (!this.user?.uid) {
            this.toastr.error('User ID not found');
            return;
        }

        this.loading = true;
        try {
            const { password } = this.formResetPassword.value;
            const response = await this.usuarioService.resetUserPassword(this.user.uid, password);
            this.toastr.success(response?.msg || 'Password reset successfully');
            this.activeModal.close(true);
        } catch (error: any) {
            this.toastr.error(error.error?.msg || 'Error resetting password');
        } finally {
            this.loading = false;
        }
    }

    closeModal(): void {
        this.activeModal.dismiss();
    }
}
